import React from "react";
import './Select.scss';

type SelectItem = {
    label: string,
    value: string|number,
}

type SelectProps = {
    className?: string,
    label?: string,
    value: string|number,
    items: Array<SelectItem>,
    disabled?: boolean,
    onChange: (value: string) => void,
};

function Select(props: SelectProps) {

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(e.target.value);
    };

    return (
        <div className={`select ${props.className ?? ''}`}>
            {props.label && (
                <span className="select-label">{props.label}</span>
            )}
            <select value={props.value} onChange={handleChange} disabled={props.disabled}>
                {props.items.map((item: SelectItem, index: number) => (
                    <option key={index} value={item.value}>{item.label}</option>
                ))}
            </select>
        </div>
    );
}

export default Select;
